import { ChangeDetectorRef, Component, Inject, Input, OnInit } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { ChangeDetectorService } from 'src/app/core/services/change-detector.service';
import { CommonFunctions } from 'src/app/shared/common-functions';
import { environment } from 'src/environments/environment';
import { PaymentGatewayService } from 'src/app/shared/services/payment-gateway.service';
import { CardRemoveSuccessComponent } from 'src/app/payment/card-remove-success/card-remove-success.component';
import { CardPaymentService } from 'src/app/shared/services/card-payment.service';
import { Router } from '@angular/router';
import { EncryptDecryptService } from 'src/app/core/services/encrypt-decrypt.service';
declare var dataLayer;
@Component({
  selector: 'app-load-msrbalance-sheet',
  templateUrl: './load-msrbalance-sheet.component.html',
  styleUrls: ['./load-msrbalance-sheet.component.scss']
})
export class LoadMSRBalanceSheetComponent implements OnInit {
  @Input() autoPrepolateAmt:any;
  public msrCardData: any;
  public cardDetails = [];
  public disableReloadBtn: boolean = true;
  public transferBalance: boolean = false;
  public reloadAmt = 0;
  public transferBalanceFromData: any;
  public userProfileInfo = JSON.parse(localStorage.getItem('user_profile'));
  public server = environment.APIEndpoint;
  public filteredMSRCards: any[];
  public queryParams: any;
  public orderStatusId: any;
  public pgOrderStatus: any;
  public pgOrderId: any;
  userType: string;
  userId: any;
  tierType: any;
  constructor(private bottomSheetRef: MatBottomSheetRef<LoadMSRBalanceSheetComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private _cdr: ChangeDetectorRef,
    private changeDetect: ChangeDetectorService,
    public dialog: MatDialog,
    public router: Router,
    private commonFunction: CommonFunctions,
    private encryptDecryptService : EncryptDecryptService,
    private paymentGatewayService: PaymentGatewayService,
    public cardsPay: CardPaymentService) {
    this.msrCardData = data;
    this.userType = this.commonFunction.getUserType();
    this.userId = this.commonFunction.getUserId();
    this.tierType = this.commonFunction.getTierType();
  }
  ngOnInit(): void {
    this.changeDetect.eventTriggerObservable.subscribe(() => {
      this._cdr.markForCheck();
    });
  }
  closeSheet() {
    this.bottomSheetRef.dismiss(true);
  }
  public listAllMsrCards(): void {
    this.commonFunction.showLoader();
    this.cardsPay.listMsrCards().subscribe((res) => {
      this.cardDetails = res['response'];
      localStorage.setItem('MSR_cards', JSON.stringify(this.cardDetails));
      localStorage.setItem('selectedMSRCardDetail', JSON.stringify(this.cardDetails[0]));
      this.commonFunction.hideLoader();
    }, (error: any) => {
      this.commonFunction.hideLoader();
      this.commonFunction.processErrorMessage(error, 'failure')
    })
  }
  isTransferBalance(event) {
    this.disableReloadBtn = true;
    if (event) {
      this.transferBalance = true;
    } else {
      this.transferBalance = false;
    }
  }
  amountSelected(event) {
    this.reloadAmt = event;
    this.disableReloadBtn = event > 0 ? false : true;
  }
  selectTransferFromAccount(event) {
    this.transferBalanceFromData = event
  }
  public reloadBalance() {
    if (this.transferBalance == true) {
      this.transaferBalance();
    } else {
      this.manualReload();
    }
  }
  public manualReload() {
    if (this.reloadAmt != 0) {
      this.disableReloadBtn = false;
      let req = {
        cardOid: null,
        loadAmount: this.encryptDecryptService.encryptData(this.reloadAmt),
        cardNumber: this.encryptDecryptService.encryptData(this.msrCardData.shortCardNumber)
      }
      this.commonFunction.showLoader();
      this.cardsPay.manualReload(req).subscribe((res) => {
        this.commonFunction.hideLoader();
        this.createPGSession(res['response'][0]['OrderId']);
        this.reloadMsrGA();
      }, (error: any) => {
        this.commonFunction.hideLoader();
        this.commonFunction.processErrorMessage(error,'failure');
      })
    } else {
      this.disableReloadBtn = true;
    }
  }
  public transaferBalance() {
    if (this.reloadAmt != 0) {
      this.disableReloadBtn = false;
      let req = {
        toCardOid: this.msrCardData.cardOid,
        fromCardOid: this.transferBalanceFromData.cardOid,
        transferAmount: this.reloadAmt
      }
      this.commonFunction.showLoader();
      this.cardsPay.transferBalance(req).subscribe((res) => {
        this.openSuccessMessageDailog();
        this.commonFunction.hideLoader();
        this.reloadMsrGA();
      }, (error: any) => {
        this.commonFunction.hideLoader();
        if (error.error.status == 400 || error.error.status == 401 || error.error.status == 500) {
          this.commonFunction.displaySnackBarMessage(error.error.response[0], 'failure');
        }
      })
    } else {
      this.disableReloadBtn = true;
    }
  }
  createPGSession(orderId) {
    this.userProfileInfo = JSON.parse(localStorage.getItem('user_profile'));
    this.commonFunction.showLoader();
    let requestPayload = {
      "order_id":  orderId,
      "amount": this.encryptDecryptService.encryptData(this.reloadAmt),
      "currency": "INR",
      "customer_email": this.userProfileInfo.emailId,
      "customer_phone": this.userProfileInfo.mobileNumber,
      "paymentMode": "ONLINE",
      "return_url": environment.PG_CALLBACK_URL + 'pay/payment-activity'
    }
    this.paymentGatewayService.createSession(requestPayload).subscribe((result: any) => {
      this.commonFunction.hideLoader();
      this.msrCardData.reloadedAmount = this.reloadAmt;
      sessionStorage.setItem('reloadedCard', JSON.stringify(this.msrCardData))
      sessionStorage.setItem('reloadCardPay', 'true')
      window.location.replace(result.response.payment_links.web);
    }, (error) => {
      this.commonFunction.hideLoader();
      this.commonFunction.displaySnackBarMessage(error.error.response[0], 'failure')
    })
  }
  commitBalanceOrder(orderId) {
    let req = {
      orderId: orderId,
      paymentStatus: this.pgOrderStatus === 'CHARGED' ? 'PaymentSuccess' : 'PaymentFailure',
    }
    this.commonFunction.showLoader();
    this.cardsPay.commitCard(req).subscribe((res) => {
      this.commonFunction.hideLoader();
      sessionStorage.setItem('reloadCardPay', 'true')
      this.router.navigate(['/pay']);
    }, (error: any) => {
      this.commonFunction.hideLoader();
      this.commonFunction.processErrorMessage(error, 'failure');
    })
  }
  openSuccessMessageDailog() {
    let obj = {
      message: 'Balance transferred successfully',
      buttonName: 'OK',
      pageFrom: 'select-payment'
    }
    const dialogRef = this.dialog.open(CardRemoveSuccessComponent, {
      width: '400px',
      panelClass: "dialog-no-padding",
      data: obj
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 'success') {
        window.location.reload();
      }
    });
  }
  crossBtnGA(){
    dataLayer.push({
      'event':'cross_click',
      'userID':this.userId,
      'user_type':this.userType,
      'tier':this.tierType
    })
  }
  /**
  * Method to call Reload Card GA event
  */
  reloadMsrGA() {
    dataLayer.push({
      'event': 'reload_msr_card_click',
      'userID': this.userId,
      'user_type': this.userType,
      'tier': this.tierType
    })
  }
}
